var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cssClass},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":""}}):_c('i',{staticClass:"fas fa-user"})])
}
var staticRenderFns = []

export { render, staticRenderFns }